import { useQuery } from "@tanstack/react-query";
import { ApiError, type FeedbackResponse, getFeedback, listAllFeedbackQueryKey } from "@/api";

/** Query key for one item; sits under the list key so list invalidations refresh it too. */
export const feedbackItemQueryKey = (uuid: string) => [...listAllFeedbackQueryKey(), uuid] as const;

/** One feedback item (GET /feedback/{uuid}). Resolves to null when it doesn't exist. */
export function useFeedbackItem(uuid: string) {
  return useQuery({
    queryKey: feedbackItemQueryKey(uuid),
    queryFn: async ({ signal }): Promise<FeedbackResponse | null> => {
      try {
        const { data } = await getFeedback({ path: { feedback_uuid: uuid }, signal, throwOnError: true });
        return data.data;
      } catch (error) {
        if (error instanceof ApiError && error.status === 404) return null;
        throw error;
      }
    },
  });
}
